import { useAuth0 } from '@auth0/auth0-react';
import icon from 'assets/img/icons/empty-card-packs.svg'

const PageBlockLogin = () => {

  const {loginWithRedirect} = useAuth0();

  return (
    <main className="main-content">
      <div className='main-content__left'></div>
      <div className="main-content__right">
        <div className="empty-packs">
          <img src={icon} className="empty-packs__pic" alt="" />
          <h2 className="empty-packs__title">Please login to see this page</h2>
          <button onClick={loginWithRedirect} className='empty-packs__link'>Log in</button>
        </div>
      </div>
    </main>
  )
}

export default PageBlockLogin
